// PolicyAt 95% completion the continue where you left off functionality should not engage,
// and completion tracking should be called
export function isNearMediaEnd(currentTime: number, duration: number): boolean {
  return currentTime / duration >= 0.95;
}
